export default "__VITE_ASSET__z4_7pqSx__"